import { ModalProps } from 'antd/lib/modal';

export const modalProps: ModalProps = {
  title: ' ',
  footer: null,
  maskClosable: false,
  width: 680,
  wrapClassName: 'email-send-modal'
};